"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.list.title': 'Profession Branches',
    'branch.list.empty': 'No branches found',
};
